export const GET_REFERENCE_BIKE_REQUEST = 'GET_REFERENCE_BIKE_REQUEST';
export const GET_REFERENCE_BIKE_REQUEST_SUCCESS = 'GET_REFERENCE_BIKE_REQUEST_SUCCESS';
export const GET_REFERENCE_BIKE_REQUEST_FAILURE = 'GET_REFERENCE_BIKE_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_reference_bike.constants.js